import SizeGuideButton from "../sizeGuideButton/SizeGuideButton";
import FitAssistantLink from "../fitAssistant/FitAssistantLink";
import { useSizing } from "../../context/sizing/SizingContext";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import useFitAssistExperiment from "../fitAssistant/useFitAssistExperiment";

export default function SizeAndFitContainer() {
  const {
    sizeGuideUrl,
    fitAssistantLinkText,
    handleFitAssistantLinkClick,
    showFitIcon,
  } = useSizing();
  const { getTranslation } = useRuntimeConstants();
  const { isSuppressed } = useFitAssistExperiment({
    fitAssistEligible: !!fitAssistantLinkText,
  });

  const showSizeGuide =
    !!sizeGuideUrl && (!fitAssistantLinkText || isSuppressed);
  const showFitAssistant = !!fitAssistantLinkText && !isSuppressed;

  return (
    <>
      {showSizeGuide && (
        <SizeGuideButton
          sizeGuideUrl={sizeGuideUrl}
          text={getTranslation("pdp_size_guide_link")}
          entryPoint="sizeguide-above-variant-selector"
        />
      )}
      {showFitAssistant && (
        <FitAssistantLink
          fitAssistantLinkText={fitAssistantLinkText}
          handleFitAssistantLinkClick={handleFitAssistantLinkClick}
          showFitIcon={showFitIcon}
        />
      )}
    </>
  );
}
